<!-- =========================================================================================
    File Name: EmailSidebar.vue
    Description: Email Application Sidebar(Filter) (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="email__email-sidebar h-full">
    <div class="m-6 clearfix">
      <!-- <vs-button class="bg-primary-gradient w-full" icon-pack="feather" icon="icon-edit" @click="activePrompt = true">Compose</vs-button> -->
    </div>
    <component :is="scrollbarTag" class="email-filter-scroll-area" :settings="settings" :key="$vs.rtl">
      <div class="px-6 pb-2 flex flex-col">
        <router-link tag="span" :to="`${baseUrl}/all`" class="flex justify-between items-center cursor-pointer" :class="{'text-primary': alarmFilter == 'all'}">
          <div class="flex items-center mb-2">
            <feather-icon icon="MailIcon" ></feather-icon>
            <span class="text-lg ml-3">전체 메시지</span>
          </div>
        </router-link>
        <router-link tag="span" :to="`${baseUrl}/new`" class="flex justify-between items-center cursor-pointer" :class="{'text-primary': alarmFilter == 'new'}">
          <div class="flex items-center mb-2">
            <feather-icon icon="MailIcon" ></feather-icon>
            <span class="text-lg ml-3">새 메시지</span>
          </div>
          <template >
            <vs-chip class="number" color="primary">{{unreadAlarmList.length}}</vs-chip>
          </template>
        </router-link>
      </div>
      <vs-divider></vs-divider>
      <div class="email__labels px-6 py-4">
        <h5 class="mb-8">Tag</h5>
        <div class="email__lables-list">
          <router-link tag="span" class="email__label flex items-center mb-4 cursor-pointer" v-for="(tag, index) in alarmTags" :key="index" :to="`${baseUrl}/${tag.value}`">
            <div class="ml-1 h-3 w-3 rounded-full mr-4" :class="'border-2 border-solid border-' + tag.color"></div>
            <span class="text-lg" :class="{'text-primary': alarmFilter == tag.value}">{{ tag.text }}</span>
          </router-link>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    alarmTags: {
      type: Array,
      required: true,
    },
    alarmFilter: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      activePrompt: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
    baseUrl() {
      const path = this.$route.path
      return path.slice(0, path.lastIndexOf("/"))
    },
    emailMeta() {
      return this.$store.state.email.meta
    },
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    unreadAlarmList(){
      return this.$store.state.alarm.newAlarms
    },
  },
  methods: {
    clearFields() {
      this.$nextTick(() => {
      })
    },
    sendMail() {
      this.clearFields()
    },
  },
  components: {
    VuePerfectScrollbar
  }
}

</script>
